import { createSlice } from '@reduxjs/toolkit';

export interface HoverIndex {
  index:number;
  isChangeCvsStyle: boolean,
  isChangeLogStyle: boolean
};

const initialState: HoverIndex = {
  index: -1,
  isChangeCvsStyle: false,
  isChangeLogStyle: false,
};

const hoverIndexSlice = createSlice({
  name: 'hoverIndex',
  initialState,
  reducers: {
    updateHoverIndex: (state, action) => {
      state.index = action.payload.value;
      state.isChangeCvsStyle = action.payload.isChangeCvsStyle;
      state.isChangeLogStyle = action.payload.isChangeLogStyle;
      return state;
    },
  },
});

export const { updateHoverIndex } = hoverIndexSlice.actions;

export default hoverIndexSlice.reducer;